$(function() {

  // open/close flyout on click or tap
  $('.flyout-trigger').on('click', function() {
    var parent = $(this).closest('.flyoutParent');
    if (parent.hasClass('open')) {
      closeFlyout();
    } else {
      openFlyout(parent[0]);
    }
  });

  // close flyout on Escape, return focus to trigger
  $(document).on('keydown', function(e) {
    if (e.key === 'Escape' && $('.flyoutParent.open').length) {
      var $trigger = $('.flyoutParent.open .flyout-trigger');
      closeFlyout();
      $trigger.focus();
    }
  });

  // define openFlyout function
  function openFlyout(flyoutParent) {
    $('.flyoutChild').stop(true, true).hide();
    $('.flyoutParent').removeClass('open');
    $('.flyout-trigger').attr('aria-expanded', 'false');
    $(flyoutParent).addClass('open');
    $(flyoutParent).find('.flyout-trigger').attr('aria-expanded', 'true');
    $('.globalNavigation').addClass('open');
    $(flyoutParent).find('.flyoutChild').first().slideDown();
  }

  // define closeFlyout function
  function closeFlyout() {
    $('.flyoutParent').removeClass('open');
    $('.flyout-trigger').attr('aria-expanded', 'false');
    $('.globalNavigation').removeClass('open');
    $('.flyoutChild').slideUp();
  }

  // add nav background on scroll
  // window.addEventListener('scroll', function() {
  //   var nav = document.querySelector('nav');
  //   if (window.scrollY > 0) {
  //     nav.classList.add('bg-white');
  //   } else {
  //     nav.classList.remove('bg-white');
  //   }
  // });


  // MOBILE NAVIGATION ------------------------------------------------------------------- //
  
  $('.mobile-nav-toggler').on('click tap', function() {
    $('#messageBar').toggleClass('hidden');
    $('#mobile-nav').slideToggle(500);
    $('body').toggleClass('no-scroll');
  });

  $('.mobile-nav-menu > .toggler').on('click tap', function() {
    $(this).parent().toggleClass('open');
  });



});